export function isMobile() {
    var maxMobileScreenWidth = 768;
    var currentWindowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    return currentWindowWidth < maxMobileScreenWidth;
}
